import { createContext } from "react";

type FeatureFlagContextType = {
    cropStagesEnabled: boolean;
    timeTravelEnabled: boolean;
    newTimeEnabled: boolean;
    notificationsV2Enabled: boolean;
    bulkRxEnabled: boolean;
    languagePreferenceEnabled: boolean;
    allNEnabled: boolean;
    sidedressOnDemandRx: boolean;
    plotEditingEnabled: boolean;
    deleteOperations: boolean;
    virtualSIEnabled: boolean;
    samplesEnabled: boolean;
    cropCyclesV2Enabled: boolean;
    bulkSIEnabled: boolean;
    weatherEnabled: boolean;
    customRecommendationsEnabled: boolean;
    bulkFieldUploadEnabled: boolean;
    fieldConfigEnabled: boolean;
    homeDashboardInsightsEnabled: boolean;
    irrigationEnabled: boolean;
    advisorEnabled: boolean;
    soilManagementRequired: boolean;
    isFetched: boolean;
    fieldIrrigationOn: (fieldId: number) => boolean;
    organizationPreviewEnabled: boolean;
    organizationMonitoringEnabled: boolean;
};

const FeatureFlagContext = createContext<FeatureFlagContextType | null>(null);

export default FeatureFlagContext;

export type { FeatureFlagContextType };
